import React, { useState, useEffect } from "react";
import MainLayout from "../../layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import MembersDetails from "./selectedDetails/membersDetails";
import {
  resetFormState,
  setSelectValidError,
} from "../../store/slices/commonSlice";
import {
  getFormRenderer,
  paymentDetails,
  readAll,
  readPrposalData,
  updateForm,
} from "../../service/proposal/proposalService";
import { useLocation, useNavigate } from "react-router-dom";
import { changeActiveTabs } from "../../store/slices/product/productSlice";
import { setCreateDetailsData } from "../../store/slices/proposal/proposalSlice";
import { getParamsFromURL } from "../../utils/helper";

function ProposalForm() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const location = useLocation();

  const createDetails = useSelector((state) => state.buyNow.createDetails);

  const [orderId, setOrderId] = useState(null);
  const [entityid, setEntityid] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);

  const customerData = useSelector((state) => state.common.customerData);
  const organizationId = customerData?.organizationid;
  const [isFormRendered, setIsFormRendered] = useState(false);
  const [isFormLoaded, setIsFormLoaded] = useState(false);

  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          const tabindex = params["tabIndex"];
          setOrderId(params["orderId"]);
          setEntityid(params["entityid"]);
          setTabIndex(parseInt(tabindex, 10));
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location]);

  useEffect(() => {
    if (entityid && organizationId) {
      getFormRenderer(entityid, organizationId)
        .then(() => {
          setIsFormRendered(true);
          setIsFormLoaded(true);
        })
        .catch((error) => {
          console.error("Error loading form renderer:", error);
        });
    }
  }, [entityid, organizationId]);

  useEffect(() => {
    if (isFormLoaded && (createDetails.entityid || orderId)) {
      readAll(createDetails?.entityid || orderId, "ODR", nav);
    }
  }, [isFormLoaded, createDetails.entityid, orderId]);

  useEffect(() => {
    if (isFormLoaded && (createDetails.entityid || orderId)) {
      // readAll(createDetails?.entityid || orderId, "ODR", nav);
      readPrposalData(createDetails?.entityid || orderId, "EDIT");
    }
  }, [isFormLoaded, createDetails.entityid, orderId]);

  useEffect(() => {
    return () => {
      dispatch(setCreateDetailsData(""));
      dispatch(resetFormState());
      dispatch(changeActiveTabs("details"));
    };
  }, [dispatch]);

  return (
    <MainLayout>
      <MembersDetails />
    </MainLayout>
  );
}

export default ProposalForm;
